import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthRoutingModule } from './auth/auth.routing';
import { LandingComponent } from './core/components/landing/landing.component';
import { MenuRoutingModule } from './menu/menu-routing.module';
import { NopagefoundComponent } from './nopagefound/nopagefound.component';

const routes: Routes = [
  {
    path: 'menu',
    loadChildren: () => import('./menu/menu.module').then(m => m.MenuModule)
  },
  {
    path: 'reserve',
    loadChildren: () => import('./reserve/reserve.module').then(m => m.ReserveModule)
  },
  {
    path: 'menu/delivery',
    loadChildren: () => import('./delivery/delivery.module').then(m => m.DeliveryModule)
  },
  { path: '', component: LandingComponent },
  { path: '**', component: NopagefoundComponent },
];

@NgModule({
  imports: [
    MenuRoutingModule,
    AuthRoutingModule,
    RouterModule.forRoot(routes),
  ], exports: [RouterModule]
})
export class AppRoutingModule { }
